import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton, Text } from '../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../shared/Helpers/functions';
import { Trash } from '../../../../shared/Assets/svgIcons';

import { DispatchProperties } from '../../../../redux/store';
import { ActiveAuthorizationProperties } from '../../../../redux/API/ClientAPIHelpers/insuranceAuthorizationProperties';
import {
	deleteAuthorization,
	getInsuranceAuthorizations,
} from '../../../../redux/State/clientSlice/insuranceAuthorizationSlice';

import './EditInsuranceAuthorization/index.scss';

const DeleteAuthorization = ({ authorizationData }: { authorizationData: ActiveAuthorizationProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { clientId } = useParams();
	const [params] = useSearchParams();

	const [open, setOpen] = useState<boolean>(false);

	const openDeleteHandler = () => {
		setOpen(true);
	};

	const fetchAuthorizations = () => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		if (!clientId) return;
		dispatch(getInsuranceAuthorizations({ clientId, page, pageSize }));
	};

	const deleteAuthorizationHandler = () => {
		if (!clientId || !authorizationData?.id) return;
		dispatch(deleteAuthorization({ authorizationId: authorizationData.id, clientId }))
			.then(unwrapResult)
			.then((response) => {
				if (!response.isSuccessful) {
					throw new Error('Failed');
				}
				fetchAuthorizations();
				toast('Success');
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<div className="actionIcon" onClick={openDeleteHandler}>
				<Trash />
			</div>
			<div className="actionContent" onClick={openDeleteHandler}>
				<Text title="Delete" type="psm" fontWeight="medium" />
			</div>
			<CustomAlert
				open={open}
				onClose={() => setOpen(false)}
				title="Deleting Insurance Authorization."
				Content={({ onClose }) => (
					<div className="deleteConfirmContent">
						<Text title="Are you sure?" type="h4" font="header" fontWeight="semiBold" className="marginBottom16" />
						<CustomButton title="Confirm" onClick={deleteAuthorizationHandler} className="marginBottom16" />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
					</div>
				)}
			/>
		</>
	);
};

export default DeleteAuthorization;
